module.exports = __webpack_public_path__ + "static/media/ROYALMAIL.88030722.svg";